import React, { useState } from 'react';
import { models } from '../data/models';
import SortDropdown from '../components/GaleryPage/SortDropdown';
import ModelCard from '../components/GaleryPage/ModelCard';

const Gallery = () => {
  const [sortOption, setSortOption] = useState('rank');

  const sortedModels = [...models].sort((a, b) => {
    switch (sortOption) {
      case 'name':
        return a.name.localeCompare(b.name);
      case 'date':
        return new Date(b.created) - new Date(a.created);
      case 'rank':
      default:
        return a.rank - b.rank;
    }
  });

  return (
    <div className="bg-opacity-0 text-white py-10 px-4 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-4xl font-bold">Model Gallery</h1>
          <SortDropdown sortOption={sortOption} onChange={setSortOption} />
        </div>

        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {sortedModels.map((model) => (
            <ModelCard key={model.slug} model={model} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
